import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the view for withdrawal requests.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        return {
            rows: [
                {
                    cols: [
                        {
                            // Define a datatable view for displaying bank account information
                            view: 'datatable',
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            id: 'bankTable', // Unique identifier for the datatable
                            scroll: true, // Enable scrolling
                            height: screen.width < 500 ? 400 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'rating', // Unique identifier for the column
                                    header: '', // No header for this column
                                    width: 50, // Column width
                                    height: 25, // Row height
                                    tooltip: 'Editar', // Tooltip text for the column
                                    template: function (obj) {
                                        // Template for rendering the edit icon
                                        return "<span class='webix_icon wxi-close edit'></span>";
                                    },
                                },
                                {
                                    id: 'Id', // Unique identifier for the column
                                    header: 'Id', // Header text for the column
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Bank', // Unique identifier for the column
                                    header: _('Banco'), // Header text with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BankAccountNumber', // Unique identifier for the column
                                    header: _('Número Cuenta Bancaria'), // Header text with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BankCodeInterbank', // Unique identifier for the column
                                    header: _('Código Interbancario'), // Header text with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BankType', // Unique identifier for the column
                                    header: _('Tipo Cuenta'), // Header text with localization
                                    options: [
                                        // Options for the dropdown editor
                                        { id: '1', value: _('Ahorros') }, // Savings account
                                        { id: '2', value: _('Corriente') }, // Current account
                                        { id: 'EVP', value: _('EVP') }, // EVP account
                                        { id: 'CPF', value: _('CPF') }, // CPF account
                                        { id: 'PHONE', value: _('PHONE') }, // Phone account
                                        { id: 'EMAIL', value: _('EMAIL') }, // Email account
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Unique identifier for the column
                                    header: _('Estado'), // Header text with localization
                                    editor: 'combo', // Editor type for dropdown selection
                                    options: [
                                        // Options for the dropdown editor
                                        { id: 'A', value: _('Activo') }, // Active state
                                        { id: 'I', value: _('Inactivo') }, // Inactive state
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for click on edit icon
                                edit: function (euv, id) {
                                    $$('editwin').show(); // Show the edit window
                                },
                            },
                            on: {
                                // Event handler before loading data
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                // Event handler after data has loaded
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            // Event handler when the datatable is ready
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            editable: true, // Enable editing of rows
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Set data fetch configuration
                            pager: 'pagerA', // Identifier for the pager component
                            // API endpoint for fetching bank account data
                            url: devConfig.geturlApi() + 'es/Client/GetClientBankAccounts?PlayerId=' + cur_user + '&',
                        },
                    ],
                },
            ],
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service for translations
        const _ = this.app.getService('locale')._;
        // Get the reference to the bank table grid
        grid = $$('bankTable');
        // Get the current user parameter
        const cur_user = this.getParam('user', true);
        // Store the URL for the grid data
        var url = grid.data.url;
        // Initialize an empty filter string
        var filter = '';
        // Create a popup window for editing bank account details
        var popup = webix.ui({
            view: 'window',
            id: 'editwin',
            head: 'Editar', // Window header
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form',
                id: 'editform', // Form ID for reference
                elements: [
                    {
                        view: 'text',
                        label: _('Banco'), // Label for the bank field
                        name: 'Bank', // Name of the field
                        readonly: true, // Make the field read-only
                        disabled: true, // Disable the field
                    },
                    {
                        view: 'text',
                        label: _('Número Cuenta Bancaria'), // Label for the bank account number field
                        name: 'BankAccountNumber', // Name of the field
                        readonly: true, // Make the field read-only
                        disabled: true, // Disable the field
                    },
                    {
                        view: 'text',
                        label: _('Código Interbancario'), // Label for the interbank code field
                        name: 'BankCodeInterbank', // Name of the field
                        readonly: true, // Make the field read-only
                        disabled: true, // Disable the field
                    },
                    {
                        view: 'combo',
                        label: _('Estado'), // Label for the state field
                        name: 'State', // Name of the field
                        options: [
                            { id: 'A', value: _('Activo') }, // Active option
                            { id: 'I', value: _('Inactivo') }, // Inactive option
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button label
                                click: function () {
                                    // Hide the popup window when clicked
                                    this.getTopParentView().hide();
                                },
                            },
                            {
                                view: 'button',
                                type: 'form', // Button type for form submission
                                value: _('Guardar'), // Save button label
                                click: function ($e) {
                                    // Get values from the form
                                    var values = $$('editform').getValues();
                                    // Send an AJAX POST request to save the bank account details
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type to JSON
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API URL
                                                'Client/SaveClientBankAccount',
                                            '{"PlayerId":' + // JSON payload
                                                cur_user +
                                                ', "Id":' +
                                                values.Id +
                                                ',"State":"' +
                                                values.State +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Show error message on failure
                                                    webix.message('Error! ');
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Show success message on successful save
                                                    webix.message({
                                                        text: _('Cuenta Bancaria editada satisfactoriamente'),
                                                        title: _('¡Exito!'), // Success title
                                                        type: 'alert-warning', // Alert type
                                                    });
                                                    // Reload the grid with updated data
                                                    grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter);
                                                },
                                            },
                                        );
                                    // Hide the popup window after saving
                                    this.getTopParentView().hide();
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Event listener for 'bankAccountReport:filter' event on the app instance
        this.on(this.app, 'bankAccountReport:filter', (filterData) => {
            // Convert filterData object into an array of key-value pairs
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize query string

            // Iterate through each entry in the filterData
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and is not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle the special case for 'Datepicker'
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log the date range for debugging
                        // Append date range to the query string
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Append other key-value pairs to the query string
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle case where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to array
                        // Iterate through each entry in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle 'start' date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object
                                    // Format date for query string
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    // Append formatted start date to the query string
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle 'end' date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object
                                        // Format date for query string
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        // Append formatted end date to the query string
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append current user ID to the query string
            string1 = string1 + '&PlayerId=' + cur_user;
            grid.clearAll(); // Clear the grid before loading new data
            // Load data into the grid with the constructed query string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the constructed filter string
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters
            grid.load(
                url +
                    '?start=0&count=' +
                    grid.data.$pagesize + // Current page size for pagination
                    filter + // Additional filter parameters
                    '&sort[' +
                    by + // Column to sort by
                    ']=' +
                    dir, // Direction of sorting (ascending/descending)
            );
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Retrieve the clicked item using its ID
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger an event with the item's ID
        });

        // Attach an event handler for the 'onBeforeEditStart' event of the grid
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id); // Retrieve the item to be edited using its ID
            console.log(item); // Log the item details to the console
            if (id.column == 'State') {
                // Check if the edited column is 'State'
                var options = this.getColumnConfig('Action').collection; // Get the collection of options for the 'Action' column
                if (item.State == 'A') {
                    // If the item's state is 'A'
                    options.remove('A'); // Remove 'A' from the options
                } else if (item.State == 'I') {
                    // If the item's state is 'I'
                    options.remove('I'); // Remove 'I' from the options
                } else {
                    return false; // Prevent editing if the state is neither 'A' nor 'I'
                }
                console.log(id); // Log the ID of the item being edited
            }
        });
        grid.attachEvent(
            'onAfterEditStop',
            /**
             * Event handler for after editing a cell in the grid.
             * @param {Object} state - The state of the edited cell.
             * @param {Object} editor - The editor instance used for editing.
             * @param {boolean} ignoreUpdate - Flag to ignore update.
             */
            function (state, editor, ignoreUpdate) {
                console.log(state); // Log the current state of the edited cell.
                var item = this.getItem(editor.row); // Retrieve the item corresponding to the edited row.
                console.log(item); // Log the retrieved item.

                // Check if the new value is different from the old value.
                if (state.value != state.old) {
                    // Handle the case when the new value is 'A'.
                    if (state.value == 'A') {
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set the content type for the request.
                            })
                            .post(
                                devConfig.geturlApi() + 'Client/AllowWithdrawalRequests', // API endpoint for allowing withdrawal requests.
                                '{ "Id":' + item.Id + '}', // JSON payload with the item ID.
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error! '); // Display error message on failure.
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        item.State = 'P'; // Update the item's state to 'P' on success.
                                        webix.message('Cell value was changed'); // Notify user of the change.
                                    },
                                },
                            );
                    }
                    // Handle the case when the new value is 'P'.
                    if (state.value == 'P') {
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set the content type for the request.
                            })
                            .post(
                                devConfig.geturlApi() + 'Client/PayWithdrawalRequests', // API endpoint for paying withdrawal requests.
                                '{ "Id":' + item.Id + '}', // JSON payload with the item ID.
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error! '); // Display error message on failure.
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        item.State = 'I'; // Update the item's state to 'I' on success.
                                        webix.message('Cell value was changed'); // Notify user of the change.
                                    },
                                },
                            );
                    }
                    // Handle the case when the new value is 'E'.
                    if (state.value == 'E') {
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set the content type for the request.
                            })
                            .post(
                                devConfig.geturlApi() + 'Client/CancelClientRequests', // API endpoint for canceling client requests.
                                '{ "Id":' + item.Id + '}', // JSON payload with the item ID.
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error! '); // Display error message on failure.
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        item.State = 'E'; // Update the item's state to 'E' on success.
                                        webix.message('Cell value was changed'); // Notify user of the change.
                                    },
                                },
                            );
                    }
                }
            },
        );
        // Attach a double-click event handler to the grid
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Retrieve the item associated with the clicked ID
            var item = this.getItem(id);
            // Show the popup for the item
            popup.show();
        });

        // Listen for the 'player:select' event on the app
        this.on(this.app, 'player:select', (id) => {
            // Load data into the grid with specified parameters
            grid.load(
                url +
                    '?start=0&count=' +
                    grid.data.$pagesize + // Set the number of items to load based on page size
                    '&PlayerId=' +
                    id, // Include the selected Player ID in the request
            );
        });

        // Bind the edit form to the bank table for data synchronization
        $$('editform').bind($$('bankTable')); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
